import axios from 'axios';
import { Message } from 'element-ui';

import { removeLocalStorage } from '@/utils/tools/utils';

import packageInfo from '../../../package.json';

// if (!store.state.token) {
//   store.commit('SET_TOKEN', sessionStorage.getItem('token'))
// }

// 集团商户 URL 替换匹配
const BLOC_MER_URL_MAP = {
  '/trade/list': '/blocMer/trade/list',
  // '/merchant/settlement/settlementBatchList': '/blocMer/merchant/settlement/settlementBatchList',
  // '/merchant/settlement/settlementInfoDetailList': '/blocMer/merchant/settlement/settlementInfoDetailList',
  '/payoutMerchant/list': '/blocMer/payoutMerchant/list',
  '/rf/listRefundApply': '/blocMer/rf/listRefundApply',
  '/chargeback/listChargeback': '/blocMer/chargeback/listChargeback',
  // '/merContract/list': '/blocMer/merContract/list',
  '/merchant/app/applist': '/blocMer/merchant/app/applist',
  '/merDispute/merchant/list': '/blocMer/merDispute/merchant/list',
  '/merchant/report/success': '/blocMer/merchant/report/success',
  '/merchant/report/repudiate': '/blocMer/merchant/report/repudiate',
  '/merchant/cardSort/pageList': '/blocMer/merchant/cardSort/pageList',
  '/merchant/cardSort/details': '/blocMer/merchant/cardSort/details',
  '/merchant/report/currency': '/blocMer/merchant/report/currency',
  '/merchant/report/repudiateDetail': '/blocMer/merchant/report/repudiateDetail',
  '/chargeback/info': '/blocMer/chargeback/info',
  '/merContract/getSubContract': '/blocMer/merContract/getSubContract',
};

// 代理商 URL 替换匹配
const PROXY_MER_URL_MAP = {
  '/merchant/account/queryAccountBalances': '/proxyMer/merchant/account/queryAccountBalances',
  '/merchant/account/listAccountRecord': '/proxyMer/merchant/account/listAccountRecord',
  '/merchant/account/downloadAccountRecord': '/proxyMer/merchant/account/downloadAccountRecord',
  // '/merchant/settlement/settlementBatchList': '/proxyMer/merchant/settlement/settlementBatchList',
  // '/merchant/settlement/settlementInfoDetailList': '/proxyMer/merchant/settlement/settlementInfoDetailList',
  // '/merchant/settlement/settlementBatchDownload': '/proxyMer/merchant/settlement/settlementBatchDownload',
  // '/merchant/settlement/settlementInfoDetailDownload': '/proxyMer/merchant/settlement/settlementInfoDetailDownload',
  '/payoutMerchant/list': '/proxyMer/payoutMerchant/list',
  '/payoutMerchant/download': '/proxyMer/payoutMerchant/download',
  '/merchant/settlement/payoutDownload': '/proxyMer/merchant/settlement/payoutDownload',
  '/collect/upload': '/proxyMer/collect/upload',
  '/merchant/payee/page': '/proxyMer/merchant/payee/page',
  '/merchant/payee/defaultAccount': '/proxyMer/merchant/payee/defaultAccount',
  '/monthReconOrder/queryMonthReconOrderList': '/proxyMer/monthReconOrder/queryMonthReconOrderList',
  '/monthReconOrder/download': '/proxyMer/monthReconOrder/download',
  '/role/list': '/proxyMer/role/list',
  '/roleResource/getInfoByRoleId': '/proxyMer/roleResource/getInfoByRoleId',
  '/role/add': '/proxyMer/role/add',
  '/role/edit': '/proxyMer/role/edit',
  '/role/delete': '/proxyMer/role/delete',
  '/merOperator/listOperator': '/proxyMer/merOperator/listOperator',
  '/merOperator/addOperator': '/proxyMer/merOperator/addOperator',
  '/merOperator/updateOperator': '/proxyMer/merOperator/updateOperator',
  '/merOperator/updateOperatorLoginPassword': '/proxyMer/merOperator/updateOperatorLoginPassword',
  '/merchant/account/getMerchantInfo': '/proxyMer/merchant/account/getMerchantInfo',
  '/merchant/share/page': '/proxyMer/merchant/share/page',
};

// 针对不同类型的商户（如：集团商户），处理成不同请求URL
const formatUrl = (store, url) => {
  let newUrl = url;
  try {
    const merchantType = store.getters.app.userLogin && store.getters.app.userLogin.merchantType ? store.getters.app.userLogin.merchantType : '';
    if (`${merchantType}` === '3') { // 集团商户时，需要判断是否更换接口
      if (BLOC_MER_URL_MAP[url]) {
        newUrl = BLOC_MER_URL_MAP[url];
      }
    } else if (`${merchantType}` === '2') { // 代理商
      if (PROXY_MER_URL_MAP[url]) {
        newUrl = PROXY_MER_URL_MAP[url];
      }
    }
  } catch (err) {

  }
  return newUrl;
};

// axios 配置
const http = axios.create({
  baseURL: '',
  timeout: 0,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8',
  },
  transformRequest: [
    function formatData(data, headers) {
      if (headers['Content-Type'] === 'multipart/form-data') {
        return data;
      }
      return JSON.stringify(data);
    },
  ],
});

export function initHttpInterceptors(store, router, i18n) {
  // 请求拦截器
  http.interceptors.request.use(
    (config) => {
      // 开发环境下，如果请求是 post,put,patch,则打印数据体，方便调试
      if (process.env.NODE_ENV === 'development') {
        const { method } = config;
        if (method === 'post' || method === 'put' || method === 'patch') {
          console.log('config.data', config.data);
        }
      }
      config.url = '/api' + formatUrl(store, config.url);
      config.headers['ow-source'] = 'merchant';
      // 加入版本号，方便定位问题
      config.headers['ow-version'] = packageInfo.version;
      return config;
    },
    (error) => {
      // if (store.state.loadingInstance) {
      //   (store.state.loadingInstance).close();
      // }
      return Promise.reject(error);
    },
  );

  // 响应拦截器
  http.interceptors.response.use(
    (res) => {
      // 未登录
      if (res.data.respCode === '00004|10023') {
        removeLocalStorage('userLogin');
        window.location.href = '/user/login';
        return Promise.reject(res.data);
      }
      // 密码过期
      if (res.data.respCode === '00005|10040') {
        removeLocalStorage('userLogin');
        window.location.href = '/user/expire-password';
      }
      // 下载
      if (res.config.responseType === 'blob') {
        return res;
      }
      if (res.data.respCode === '11000' || res.data.respCode === '00004|00002|00026' ||
        [
          '00004|14006',
          '00004|14000',
          '00004|14001',
          '00004|14002',
          '00004|14003',
          '00004|14004',
          '00004|14005',
          '00019|50026',
        ].includes(res.data.respCode)) { //  不显示提示信息
        return Promise.reject(res.data);
      }
      // 00022|00011
      if (res.data.respCode === '00022|00011') {
        const message = i18n.tc('message.common.blacklistOfSameTypeExist');
        Message.error({ message });
        return Promise.reject(message);
      }
      // 请求失败：显示错误提示消息
      if (res.data.respCode !== '20000') {
        Message.error(res.data.respMsg);
        return Promise.reject(res.data);
      }

      return res.data.data;
    },
    (error) => {
      Message.error({ message: i18n.tc('message.common.requestError') });
      // if (store.state.loadingInstance) {
      //   (store.state.loadingInstance).close();
      // }
      if (error && error.response) {
        switch (error.response.status) {
          // 401 token失效
          case 401:
            // router.push('/login');
            break;
          // 403 服务器拒绝访问
          case 403:
            // router.push('/error/403');
            break;
          // 404 访问的资源不存在
          case 404:
            // router.push('/error/404');
            break;
          // 500 服务器错误
          case 500:
            // router.push('/error/500');
            break;
          default:
            // router.push('/error/404');
            break;
        }
        return Promise.reject(error);
      }
      return Promise.reject(error);
    },
  );
}

export default http;
